import { saveAllDailyMessages } from './ajax.js';

const MESSAGE_DAYS = ['message_day_1', 'message_day_2', 'message_day_3', 'message_day_4', 'message_day_5', 'message_day_6', 'message_day_7'];

let container = null;
let saveButton = null;

/**
 * Initialize daily messages module
 * Sets up event listeners for save functionality
 */
export function initDailyMessages() {
	container = document.getElementById('daily-messages');
	if (!container) return;

	// Setup save button
	saveButton = container.querySelector('.save-daily-message-btn');
	if (saveButton) {
		saveButton.addEventListener('click', handleSaveClick);
	}
}

/**
 * Handle save button click
 * Saves all messages at once
 */
async function handleSaveClick() {
	const stageId = container.getAttribute('data-stage-id');
	if (!stageId) return;

	const messages = {};

	// Collect all message values
	MESSAGE_DAYS.forEach(day => {
		const textarea = container.querySelector(`textarea[name="${day}"]`);
		if (textarea) {
			messages[day] = textarea.value.trim();
		}
	});

	// Disable button during save
	saveButton.disabled = true;
	saveButton.textContent = wpcore.direct_t({ en: 'Saving...', fr: 'Enregistrement...' });

	const success = await saveAllDailyMessages(stageId, messages);

	if (success) {
		saveButton.textContent = wpcore.direct_t({ en: 'Saved!', fr: 'Enregistr\u00e9 !' });
		setTimeout(() => {
			saveButton.textContent = wpcore.direct_t({ en: 'Save', fr: 'Enregistrer' });
			saveButton.disabled = false;
		}, 1500);
	} else {
		saveButton.textContent = wpcore.direct_t({ en: 'Error!', fr: 'Erreur !' });
		setTimeout(() => {
			saveButton.textContent = wpcore.direct_t({ en: 'Save', fr: 'Enregistrer' });
			saveButton.disabled = false;
		}, 1500);
	}
}
